import { render, staticRenderFns } from "./TranscriptionSpeaker.vue?vue&type=template&id=73a8445f"
import script from "./TranscriptionSpeaker.vue?vue&type=script&lang=js"
export * from "./TranscriptionSpeaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports